<template>
  <div class="card-views-shell">
    <loading v-if="refreshload" backcolor="#ffa976"></loading>
    <BenefitCardListPanel
      ref="listPanel"
      @cards-loaded="onCardsLoaded"
    />
    <foot-nav />
  </div>
</template>

<script>
import FootNav from '../../components/footnav/FootNav.vue';
import BenefitCardListPanel from './components/BenefitCardListPanel.vue';

export default {
  name: 'CardViews',
  components: { FootNav, BenefitCardListPanel },
  inject: ['reload'],
  data() {
    return {
      refreshload: true,
    };
  },
  methods: {
    onCardsLoaded() {
      this.refreshload = false;
    },
    initPage() {
      this.refreshload = true;
      this.$nextTick(() => {
        const panel = this.$refs.listPanel;
        if (!panel) {
          this.refreshload = false;
          return;
        }
        panel.initFromRoute(this.$route).catch(() => {
          this.refreshload = false;
        });
      });
    },
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.reload();
    });
  },
  mounted() {
    const browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
    if (browserRule.test(navigator.userAgent)) {
      window.onpageshow = function (event) {
        if (event.persisted) {
          window.location.reload();
        }
      };
    }
    this.initPage();
  },
};
</script>

<style lang="scss" scoped>
.card-views-shell {
  position: relative;
  height: 100vh;
  display: flex;
  flex-direction: column;

  :deep(.benefit-card-page) {
    flex: 1;
    min-height: 0;
  }
}
</style>
